import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { BookPage } from './routes/BookPage';
import { MyBookingsPage } from './routes/MyBookingsPage';
import { useMe } from './queries';
import { signOut } from './auth';

export function App() {
  const me = useMe();

  return (
    <div className="app">
      <header className="topbar">
        {/* Text wordmark rather than the Scatec logo: drop the real
            asset in here once you have an SVG of it. */}
        <span className="wordmark">Scatec Booking</span>
        <nav>
          <NavLink to="/book">Book</NavLink>
          <NavLink to="/bookings">Yours</NavLink>
        </nav>
        <span className="spacer" />
        <span className="who">{me.data?.displayName}</span>
        <button onClick={() => signOut()}>Sign out</button>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/book" replace />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/bookings" element={<MyBookingsPage />} />
          <Route path="*" element={<Navigate to="/book" replace />} />
        </Routes>
      </main>
    </div>
  );
}
